import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MainLayout = () => {
  const { i18n } = useTranslation();
  const [isDark, setIsDark] = useState(
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  const bgImage = isDark ? `${process.env.PUBLIC_URL}/assets/Dark.png` : `${process.env.PUBLIC_URL}/assets/Light.png`;
  const isRTL = i18n.language.startsWith("ar");

  return (
    <div
      dir={isRTL ? "rtl" : "ltr"}
      className="relative flex h-[100dvh] w-full overflow-hidden dark:text-white"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* المحتوى */}
      <div className="relative z-10 w-full h-full flex">
        <Sidebar />
        <main className="flex-1 overflow-y-auto md:overflow-hidden p-4 md:p-6 w-full flex flex-col">
          <div className="w-full max-w-screen-2xl mx-auto flex flex-col md:h-full md:min-h-0 flex-1">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
